import ModalPageWrapper from "../../components/global-layout/modal-page-wrapper";
import CreateMasterDetails from "../../components/section/master-details/create-master-details";

function CreateMasterDetailsWrapper({ masterDetailsUpdated }: any) {
  return (
    <ModalPageWrapper>
      <div className="w-[41%] h-full bg-io-white dark:bg-io-black-15 ml-auto max-md:w-[85%]">
        <CreateMasterDetails masterDetailsUpdated={masterDetailsUpdated} />
      </div>
    </ModalPageWrapper>
  );
}
export default CreateMasterDetailsWrapper;
